import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { RealityCheckData } from "@obg/ngx.core";
import { CurrencyService } from "@obg/ngx.global";

@Component({
	selector: "obg-dga-reality-check",
	templateUrl: "./dga-reality-check-info.component.html",
	styleUrls: ["./dga-reality-check-info.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DgaRealityCheckComponent {
	@HostBinding("class.obg-dga-reality-check") hostCssClass = true;

	@Input() set data(value: RealityCheckData | undefined) {
		if (!value) {
			return;
		}

		const totalWins = value.totalWins || 0;
		const totalBets = value.totalBets || 0;
		this.elapsedMinutes = value.elapsedMinutes || 0;
		this.totalLosses = this.currency.format(totalBets - totalWins);
		this.totalWins = this.currency.format(totalWins);
	}

	totalLosses: string | null | undefined;
	totalWins: string | null | undefined;
	elapsedMinutes: number | null | undefined;

	constructor(private currency: CurrencyService) {}
}
